import React from 'react';
import { Link } from 'gatsby';
import { Spring } from 'react-spring/renderprops';
import isExternalLink from '../../util/isExternalLink';
import Caret from '../../assets/icons/chevron_right.svg';
import { useTranslation } from 'react-i18next';

import SearchBar from '../SearchBar/SearchBar';

const OffCanvas = React.memo(({ links, onClose }) => {
  const { t } = useTranslation();
  return (
    <section className="off-canvas" >
      <div class="scroll-content">
        <SearchBar autoFocus={false} preNavigate={onClose} />
        <nav aria-labelledby="label-canvas-menu" className="canvas-menu-wrapper">
          <h3 id="label-canvas-menu" className="sr-only">Hoofdnavigatie</h3>
          <Spring
            duration={50}
            delay={400}
            from={{ opacity: 0, transform: 'translateY(10%)' }}
            to={{ opacity: 1, transform: 'translateY(0%)' }}
          >
            {props => (
              <ul className="canvas-menu" style={props}>
                <li>
                    <Link to={t('home_url')} activeClassName="current" onClick={onClose}><Caret /> Home</Link>
                  </li>
                  {links && links.map(link => (
                    <li key={link.url.path}>
                      {isExternalLink(link.url.path)
                        ? <a href={link.url.path}><Caret /> {link.label}</a>
                        : <Link to={link.url.path} activeClassName="current" partiallyActive onClick={onClose}><Caret /> {link.label}</Link>
                      }
                    </li>
                  ))}
              </ul>
            )}
          </Spring>
        </nav>
      </div>
    </section>
  );
});

export default OffCanvas;
